export var addressMock = {
  line1: 'Address Line 1',
  line2: 'Address Line 2',
  city: 'Example City',
  region: 'Example State',
  postalCode: 'Example Postal Code'
};
export var inputMock = {
  name: 'username',
  id: 'username',
  type: 'text',
  label: 'User Name'
};
export var selectMock = {
  name: 'select',
  options: [{
    value: 'option-1',
    label: 'Option 1'
  }, {
    value: 'option-2',
    label: 'Option 2'
  }, {
    value: 'option-3',
    label: 'Option 3'
  }]
};
export var yextMockData = [{
  "address": {
    "line1": "29229 Canwood St. Suite 100",
    "city": "Agoura Hills",
    "region": "CA",
    "postalCode": "91301",
    "countryCode": "US"
  },
  "alternatePhone": "+12345678901",
  "logo": {
    "image": {
      "url": "http://a.mktgcdn.com/p/g4UjQTS_w8PksIsB0wgkdfSzVMWizUCUtRDYQg4RyTc/995x995.png",
      "alternateText": "NVA",
      "width": 995,
      "height": 995,
      "sourceUrl": "http://a.mktgcdn.com/p/g4UjQTS_w8PksIsB0wgkdfSzVMWizUCUtRDYQg4RyTc/995x995.png",
      "thumbnails": [{
        "url": "http://a.mktgcdn.com/p/g4UjQTS_w8PksIsB0wgkdfSzVMWizUCUtRDYQg4RyTc/995x995.png",
        "width": 995,
        "height": 995
      }, {
        "url": "http://a.mktgcdn.com/p/g4UjQTS_w8PksIsB0wgkdfSzVMWizUCUtRDYQg4RyTc/619x619.png",
        "width": 619,
        "height": 619
      }, {
        "url": "http://a.mktgcdn.com/p/g4UjQTS_w8PksIsB0wgkdfSzVMWizUCUtRDYQg4RyTc/450x450.png",
        "width": 450,
        "height": 450
      }, {
        "url": "http://a.mktgcdn.com/p/g4UjQTS_w8PksIsB0wgkdfSzVMWizUCUtRDYQg4RyTc/196x196.png",
        "width": 196,
        "height": 196
      }]
    },
    "clickthroughUrl": "http://www.nva.com"
  },
  "name": "NVA",
  "cityCoordinate": {
    "latitude": 34.14617,
    "longitude": -118.76126
  },
  "c_birdEyeID": "",
  "c_googleMyBusinessCID": "",
  "c_websiteID": "1",
  "facebookCoverPhoto": {
    "url": "http://a.mktgcdn.com/p/gBC44th-VKEbClp00oS197xLICbhmVeQurNQFnC2KU0/720x266.jpg",
    "width": 720,
    "height": 266,
    "sourceUrl": "http://a.mktgcdn.com/p/gBC44th-VKEbClp00oS197xLICbhmVeQurNQFnC2KU0/720x266.jpg"
  },
  "facebookPageUrl": "https://www.facebook.com/NationalVeterinaryAssociates/",
  "facebookProfilePhoto": {
    "url": "http://a.mktgcdn.com/p/k0Lhi5jNBt3YKVh6t6ct_D2AAmBb4t1I1zY0QvvKm2k/200x200.png",
    "width": 200,
    "height": 200,
    "sourceUrl": "http://a.mktgcdn.com/p/k0Lhi5jNBt3YKVh6t6ct_D2AAmBb4t1I1zY0QvvKm2k/200x200.png"
  },
  "featuredMessage": {
    "description": "Join Us. Stay You."
  },
  "geocodedCoordinate": {
    "latitude": 34.1474758,
    "longitude": -118.7630668
  },
  "instagramHandle": "nvapets",
  "isoRegionCode": "CA",
  "mainPhone": "+12345678901",
  "specialities": ["Test"],
  "timezone": "America/Los_Angeles",
  "twitterHandle": "nvaonline",
  "websiteUrl": {
    "url": "http://www.nva.com",
    "displayUrl": "http://www.NVA.com",
    "preferDisplayUrl": false
  },
  "yearEstablished": 1996,
  "yextDisplayCoordinate": {
    "latitude": 34.1474758,
    "longitude": -118.7630668
  },
  "yextRoutableCoordinate": {
    "latitude": 34.1468310058527,
    "longitude": -118.762932208639
  },
  "meta": {
    "accountId": "",
    "uid": "",
    "id": "0100",
    "timestamp": "2023-06-12T13:45:30",
    "folderId": "266128",
    "schemaTypes": ["LocalBusiness"],
    "language": "en",
    "countryCode": "US",
    "entityType": "location"
  },
  "categoryIds": ["325"],
  "timeZoneUtcOffset": "-08:00"
}];
export var locatorFinderFormMock = {
  __typename: "LocatorMap",
  name: "Location Blade - PetSuites of America - All Locations - Accordion",
  variation: "Accordion List by Region",
  fontColor: null,
  anchorLink: null,
  bodyText: null,
  cta: null,
  bladeCta: null,
  gridViewColumnCount: null,
  locationInformation: null,
  cardsCta: null,
  headline: null,
  subHeadline: null,
  mapFilterOptions: null,
  mapFilterSearch: null,
  locationContainer: {
    __typename: "LocationContainer",
    yextIds: null,
    yextFolderIds: ["266125"]
  },
  background: {
    __typename: "OverrideBackground",
    backgroundId: "white",
    colorBackground: null,
    imageBackground: null
  }
};
export { accordionMock1, accordionMock2 } from '../components/molecules/Accordion/Accordion.mock';
export { textCardMock1, textCardMock2, textCardMock3, textCardMock4 } from '../components/molecules/TextCard/TextCard.mock';
export { mediaTextCarouselVariationA, mediaTextCarouselVariationB, mediaTextCarouselVariationC, mediaTextCarouselVariationAVideo, mediaTextCarouselVariationClass } from '../components/molecules/MediaTextCarousel/MediaTextCarousel.mock';
export { ImageGalleryDataVariationA, ImageGalleryDataVariationB } from '../components/molecules/ImageGallery/ImageGallery.mock';
export { varitaionOne as fiftyFifty1 } from '../components/molecules/FiftyFiftyCard/FiftyFiftyCard.mock';
import { logoImage, contactUsObject, addressObject, hoursOfOperationObject, mapImage, primaryLinksObject, utilityLinksObject, socialIconsData } from '../components/molecules/Footer/Footer.mock';
export var footerMock = {
  logoImage: logoImage,
  contactUsObject: contactUsObject,
  addressObject: addressObject,
  hoursOfOperationObject: hoursOfOperationObject,
  mapImage: mapImage,
  primaryLinksObject: primaryLinksObject,
  utilityLinksObject: utilityLinksObject,
  socialIconsData: socialIconsData
};
export { heroCarouselVariationA } from '../components/organisms/HeroCarousel/HeroCarousel.mock';
export { fiveCardVariationA, fiveCardVariationB } from '../components/organisms/FiveCard/FiveCard.mock';
export { threeTileDataVariationA, threeTileDataVariationAWithCTA, threeTileDataVariationB, threeTileDataVariationC } from '../components/organisms/ThreeTile/ThreeTile.mock';
export { fiftyFiftyVariationA, fiftyFiftyVariationB, fiftyFiftyVariationB_CTA_null } from '../components/organisms/FiftyFifty/FiftyFifty.mock';
export { topNavMock } from '../components/molecules/Header/TopNav/TopNav.mock';
export { mockData as bottomNavMock } from '../components/molecules/Header/BottomNav/BottomNav.mock';
export { generalPracticeHeaderMock } from '../components/organisms/GlobalHeader/GlobalHeader.mock';
export { promoDataVariationA as alertMock } from '../components/organisms/Alert/Alert.mock';
export { promoDataVariationA as pencilBannerMock } from '../components/organisms/PencilBanner/PencilBanner.mock';
export { dto as serviceDetailsMock } from '../components/organisms/ServiceDetail/ServiceDetail.mock';
export { mockData as serviceBladeMock } from '../components/organisms/ServicesBlade/ServicesBlade.mock';
export { mockData as serviceBladeDetailedListingMock } from '../components/organisms/ServicesBladeDetailedListing/ServicesBladeDetailedListing.mock';
export default {
  addressMock: addressMock,
  inputMock: inputMock
};